<template>
  <div class="p-6 bg-indigo-800 min-h-screen flex flex-col justify-center items-center">
    <div class="w-full max-w-md">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
          <h1 class="text-center font-bold text-3xl">Welcome Back!</h1>
          <div class="mx-auto mt-6 w-24 border-b-2" />
          <text-input v-model="form.login" :errors="$page.props.errors.login" class="mt-10" label="Mobile or Email" type="text" autofocus autocapitalize="off" />
          <text-input v-model="form.password" class="mt-6" label="Password" type="password" />
          <label class="mt-6 select-none flex items-center" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox">
            <span class="text-sm">Remember Me</span>
          </label>
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-200 flex justify-between items-center">
          <a class="hover:underline" tabindex="-1" :href="route('customer.password.reset')">Forget password?</a>
          <loading-button :loading="sending" class="btn-primary" type="submit">Login</loading-button>
        </div>
      </form>
    </div>

    <div class="w-full max-w-md mt-5" v-if="canRegister">
      <div class="px-10 py-4 bg-gray-100 border-t border-gray-200 flex justify-between items-center rounded-lg">
        <p>Don't have an account?</p>
        <a :href="route('customer.register')" class="btn-primary btn-primary cursor-pointer">Register</a>
      </div>
    </div>

    <!--  TODO remove this when expired -->
    <promotion-link-button class="mt-4" expiry-date="2020-12-01" primary-text="AKBAR SCRATCH CODE !" action-text="Click here to send" link="https://bhm.mv"></promotion-link-button>

  </div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import PromotionLinkButton from '@/Shared/PromotionLinkButton'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    Logo,
    TextInput,
    PromotionLinkButton
  },
  props: {
    errors: Object,
    canRegister: Boolean
  },
  data() {
    return {
      sending: false,
      form: {
        login: null,
        password: null,
        remember: null,
      },
    }
  },
  methods: {
    submit() {
      this.sending = true
      this.$inertia.post(this.route('customer.login'), {
        login: this.form.login,
        password: this.form.password,
        remember: this.form.remember,
      }).then(() => this.sending = false)
    },
  },
}
</script>
